import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, switchMap } from 'rxjs';
import { ExamdojoAuthService } from '../abstract-auth.service';
import { GoogleCloudTokenExchangeService } from './google-cloud-token-exchange.service';

@Injectable()
export class BigQueryAuthInterceptor implements HttpInterceptor {
  constructor(
    private readonly authService: ExamdojoAuthService,
    private readonly tokenExchangeService: GoogleCloudTokenExchangeService,
  ) {}

  private readonly bigQueryUrlPattern = /^https:\/\/bigquery\.googleapis\.com/;

  intercept(req: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    if (!this.bigQueryUrlPattern.test(req.url)) {
      return next.handle(req);
    }

    return this.authService.selectAccessToken().pipe(
      switchMap((supabaseToken) => {
        if (!supabaseToken) {
          return next.handle(req);
        }

        return this.tokenExchangeService.exchangeToken(supabaseToken).pipe(
          switchMap((googleCloudToken) => {
            const authenticatedRequest = req.clone({
              setHeaders: {
                Authorization: `Bearer ${googleCloudToken}`,
              },
            });
            return next.handle(authenticatedRequest);
          }),
        );
      }),
    );
  }
}
